import { v5 as uuidv5 } from 'uuid';
let NAMESPACE = null;
export function setLGPDConsentBanner(_id) {
  if (NAMESPACE) {
    const uuid = uuidv5(_id, NAMESPACE);
    console.log('lgpd setConsentBanner', _id, uuid);
    window.setConsentBannerParams({ uuid });
  }
}

export default (sharedIntegrations) => {
  if (sharedIntegrations && sharedIntegrations.SECURITI_LGPD) {
    const {
      tenantId,
      domainId,
      backendUrl,
      sdkStubUrl,
      cookieConsentUrl,
      styleUrl,
      enabled,
    } = sharedIntegrations.SECURITI_LGPD;
    if (
      tenantId &&
      domainId &&
      backendUrl &&
      sdkStubUrl &&
      cookieConsentUrl &&
      styleUrl &&
      enabled
    ) {
      NAMESPACE = '8b1fd320-42c8-58d3-8a33-7448bf5514c4';
      let parentNode = document.head || document.body;

      // initialize Securiti.ai banner style
      let securitiStyle = document.createElement('link');
      securitiStyle.rel = 'stylesheet';
      securitiStyle.type = 'text/css';
      securitiStyle.href = styleUrl;
      parentNode.appendChild(securitiStyle);
      // initialize Securiti.ai base code
      let securitiStub = document.createElement('script');
      securitiStub.src = sdkStubUrl;

      parentNode.appendChild(securitiStub);

      // set Securiti.ai config
      let s = document.createElement('script');
      s.src = cookieConsentUrl;
      s.setAttribute('data-tenant-uuid', tenantId);
      s.setAttribute('data-domain-uuid', domainId);
      s.setAttribute('data-backend-url', backendUrl);
      s.setAttribute('data-skip-css', 'false');
      s.defer = true;

      parentNode.appendChild(s);

      s.addEventListener('load', function () {
        console.log('lgpd loaded');
        window.initCmp();
      });
      return { setLGPDConsentBanner };
    }
  }
};



// WEBPACK FOOTER //
// ./src/services/lgpdSecuriti.js